import React, { useState, useEffect } from "react"

import DocumentsTable from "../../Tables/DocumentsTable";
import usePostGetDocuments from "../../Api/usePostGetDocuments";
import usePostAddDocument from "../../Api/usePostAddDocument";
import usePostRemoveDocuments from "../../Api/usePostRemoveDocuments";
import Loading from "../../Ui/Loading";

import { TableMode } from "../../enums/TableTypes";
import EditUploadedDocumentPopup from "../../Popups/EditUploadedDocument";

import { useAppSelector } from "../../Hooks/hooks";


type props = {
    withOutSign?: boolean;
}
export default function ProfileDocuments({ withOutSign }:props) {
    const { mutate: getDocuments, data, isError, error, isPending } = usePostGetDocuments();
    const { mutate: addDoc, data: addDocumentResult, isPending: addDocumentLoading, isError: addDocumentIsError, isSuccess: addDocumentSuccess, error: addDocumentError } = usePostAddDocument();
    const [documents, setDocuments] = useState(data);

    useEffect(() => {
        getDocuments(null);
    }, [])

    useEffect(() => {
        if (data) setDocuments(data);
    }, [data])

    const handleDocument = (data) => {
        addDoc(data);
    }

    return (
        <>
            {isPending && <Loading />}

            <EditUploadedDocumentPopup
                handleDocument={handleDocument}
                updateDocuments={() => { getDocuments(null) }}
                CanUploadFromAllDocs={false}
                MaxSizeFile={2}

                isLoading={addDocumentLoading}
                isError={addDocumentIsError}
                isSuccess={addDocumentSuccess}
                error={addDocumentError}
            />

            <DocumentsTable
                data={documents}
                getDocuments={getDocuments}
                removeDocument={usePostRemoveDocuments}
                Mode={TableMode.Edit}
                onRemove={(docId) => setDocuments(prev => prev.filter(doc => doc.Id !== docId))}
                withOutSign={withOutSign}
            />
        </>
    )
}